import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { courses } from '@/mocks/homeData';

export default function CoursesSection() {
  const ref = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.unobserve(el); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-6">
        <div className={`flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4 anim-fade-up ${isVisible ? 'is-visible' : ''}`}>
          <div className="text-center md:text-left">
            <span className="inline-block text-xs font-bold tracking-widest text-[#C9A84C] uppercase border border-[#C9A84C]/40 rounded-sm px-3 py-1 mb-4">Academy</span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-[#1B3A6B]">전문 교육 과정</h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs leading-relaxed text-center md:text-right mx-auto md:mx-0">실무 중심의 체계적인 커리큘럼으로 현장에서 바로 활용 가능한 기술을 습득합니다</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {courses.map((course, i) => (
            <div
              key={course.id}
              className={`group rounded-xl overflow-hidden border border-gray-100 hover:border-[#1B3A6B]/20 transition-all duration-300 bg-white cursor-pointer card-lift anim-scale-up ${isVisible ? 'is-visible' : ''}`}
              style={{ transitionDelay: isVisible ? `${i * 120}ms` : '0ms' }}
            >
              <div className="relative h-48 overflow-hidden">
                <img src={course.image} alt={course.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute top-3 left-3 bg-[#C9A84C] text-white text-xs font-bold px-3 py-1 rounded-sm">{course.badge}</span>
                <span className="absolute top-3 right-3 bg-white/90 text-[#1B3A6B] text-xs font-semibold px-3 py-1 rounded-sm">{course.duration}</span>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-xs font-semibold tracking-widest text-[#C9A84C] uppercase mb-2">{course.subtitle}</p>
                <h3 className="text-base md:text-lg font-bold text-[#1B3A6B] mb-3">{course.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{course.desc}</p>
                <Link to="/academy" className="flex items-center gap-1.5 text-sm font-semibold text-[#1B3A6B] hover:text-[#C9A84C] transition-colors cursor-pointer">
                  자세히 보기 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center mt-10 md:mt-12 anim-fade-up ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: isVisible ? '400ms' : '0ms' }}>
          <Link to="/academy" className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md border-2 border-[#1B3A6B] text-[#1B3A6B] font-bold hover:bg-[#1B3A6B] hover:text-white transition-all cursor-pointer w-full sm:w-auto">
            전체 교육과정 보기 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
